// extracted by mini-css-extract-plugin
export default {"button":"strava-connect-button_button__t2bv5","icon":"strava-connect-button_icon__5z+4v","spinner":"strava-connect-button_spinner__8oXmK","spin":"strava-connect-button_spin__Vmxlh"};